import { getProjectId } from "./isContactedProject";

const BUCKET_SUFFIXES = ["_buy", "_rent", "-buy", "-rent"];

function isPropertyBucketKey(key) {
  if (typeof key !== "string") return false;
  const k = key.toLowerCase();
  return (
    k.includes("apartment") ||
    k.includes("villa") ||
    k.includes("plot") ||
    k.includes("project") ||
    k.includes("lead") ||
    k.includes("contact")
  );
}

function looksLikeProjectRow(row) {
  if (!row || typeof row !== "object" || Array.isArray(row)) return false;
  return Boolean(getProjectId(row) || row.project_id != null || row.id != null);
}

/**
 * Collect unique project IDs from GET /lead-submissions payloads (any shape).
 */
export function extractContactedProjectIds(payload) {
  const ids = new Set();
  if (!payload) return ids;

  const visit = (node, depth = 0) => {
    if (!node || depth > 8) return;

    if (Array.isArray(node)) {
      node.forEach((row) => {
        if (looksLikeProjectRow(row)) {
          const id = getProjectId(row);
          if (id) ids.add(id);
        } else {
          visit(row, depth + 1);
        }
      });
      return;
    }

    if (typeof node !== "object") return;

    if (looksLikeProjectRow(node)) {
      const id = getProjectId(node);
      if (id) ids.add(id);
    }

    if (node.data != null) visit(node.data, depth + 1);

    for (const [key, value] of Object.entries(node)) {
      if (key === "data") continue;
      if (Array.isArray(value)) {
        if (isPropertyBucketKey(key) || value.some(looksLikeProjectRow)) {
          visit(value, depth + 1);
        }
      } else if (value && typeof value === "object") {
        const keyLower = String(key).toLowerCase();
        if (
          isPropertyBucketKey(key) ||
          BUCKET_SUFFIXES.some((s) => keyLower.includes(s.replace("_", "")))
        ) {
          visit(value, depth + 1);
        }
      }
    }
  };

  visit(payload);
  return ids;
}
